module.exports = __webpack_public_path__ + "img/img_title_flow-path.1feb975f.png";